export var EDIT_ICON = 'pencil';
export var SAVE_ICON = 'save';
export var HIDE_ICON = 'chevron up';
export var SHOW_ICON = 'chevron down';